import { COLORS } from '@btime/constants'
import React from 'react'

import DynamicBlockModal from './DynamicBlockModal'
import DynamicBlockTable from './DynamicBlockTable'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const DynamicBlock = ({ value, onChange, blockQuestions }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(false)

  return (
    <>
      {!!value?.length && (
        <DynamicBlockTable
          value={value}
          blockQuestions={blockQuestions}
          onEdit={setSelectedIndex}
          onChange={onChange}
        />
      )}
      <Panel padding={0.6} borderColor={COLORS.light5} onClick={() => setSelectedIndex(-1)}>
        <IconText
          justify="center"
          label="Adicionar novo item"
          color={COLORS.dark4}
          iconLeft="BsPlusCircle"
          iconSize={1}
        />
      </Panel>
      <Separator weight={4} />
      <DynamicBlockModal
        selectedIndex={selectedIndex}
        onClose={() => setSelectedIndex(false)}
        blockQuestions={blockQuestions}
        value={value || []}
        onChange={onChange}
      />
    </>
  )
}

export default DynamicBlock
